<template>
  <div class="home-page">
    <div class="home-page_inner">
      <header>
        <span class="logo">
          <img src="/images/pro.svg" alt="pro" />
          <span style="margin-left:12px;font-size: 16px;">个人工具站点</span>
        </span>
        <div class="menu">
          <div class="menu-item" @click="goTo('tv')">🔥我的影院</div>
          <div class="menu-item" @click="goTo('weather')">天气面板</div>
          <!-- <div class="menu-item" @click="goTo('json')">JSON配置</div> -->
        </div>
      </header>
      <main>
        <!-- 天气面板 -->
        <section>
          <div class="section-header">
            <span class="section-header_title">
              <span class="section-header_title-inner">天气面板</span>
            </span>
          </div>
          <div class="section-content">
            <div class="section-content_left">
              <h2>实时天气查看</h2>
              <p>
                全国相关城市的天气实时数据查看, 北京/重庆/济南/无锡/广州.....
              </p>
              <h2>历史天气查询</h2>
              <p>可选择日期,进行城市日期历史天气查询~</p>

              <el-button
                class="enter-button"
                type="primary"
                @click="goTo('weather')"
                >进入「天气面板」</el-button
              >
            </div>
            <img class="section-content_right" src="/images/weather.svg" alt />
          </div>
        </section>
        <!-- JSON配置器 -->
        <!-- <section>
          <div class="section-header">
            <span class="section-header_title" style="width:220px">
              <span class="section-header_title-inner"
                >运营活动JSON快速生成器</span
              >
            </span>
          </div>
          <div class="section-content">
            <div class="section-content_left">
              <h2>极大提高运营活动的批量配置效率</h2>
              <p>贴入EXCEL或者CSV数据, 即可自动转换成所需要的JSON!</p>
              <h2>基于不同的活动类型，提高准确率</h2>
              <p>可自定义通用配置字段,字段会自动混入到粘贴的数据中</p>

              <el-button
                class="enter-button"
                type="primary"
                @click="goTo('json')"
                >进入「JSON配置」</el-button
              >
            </div>
            <img class="section-content_right" src="/images/toghter.svg" alt />
          </div>
        </section> -->
        <section>
          <div class="section-header">
            <span class="section-header_title" style="width:220px">
              <span class="section-header_title-inner">我的影音库</span>
            </span>
          </div>
          <div class="section-content">
            <div class="section-content_left">
              <h2>想要啥，就有啥</h2>
              <p>全网最新最火视频</p>
              <el-button class="enter-button" type="primary" @click="goTo('tv')">进入「我的影音库」</el-button>
            </div>
            <img class="section-content_right" src="/images/tv.svg" alt>
          </div>
        </section>
        <!-- TV -->
      </main>
      <div id="beian" @click="goBeian">京ICP备20005656号-4</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goTo(name) {
      if (name === 'tv') {
        window.open("https://tv.qinghuan.pro")
        return
      }
      this.$router.push({ name });
    },
    goBeian() {
      window.open('https://beian.miit.gov.cn/');
    },
  },
};
</script>

<style lang="less">
.home-page {
  background: #090723;
  min-width: 100%;
  min-height: 100vh;
  color: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  font-family: Tahoma, Helvetica, Arial, sans-serif;
  overflow-x: hidden;
  .home-page_inner {
    width: 1160px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  header {
    display: flex;
    align-items: center;
    height: 55px;
    line-height: 55px;
    .logo {
      display: flex;
      color: rgba(255, 255, 255, 0.9);
      align-items: center;
      font-size: 20px;
      font-family: monospace, Georgia, Serif;
      img {
        height: 26px;
        margin-left: 5px;
      }
    }
    .menu {
      display: flex;
      margin-left: 20px;
      font-size: 14px;
      .menu-item {
        font: 14px Tahoma, Helvetica, Arial, '\5b8b\4f53', sans-serif;
        height: 55px;
        line-height: 55px;
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }
  main {
    margin-top: 50px;
    color: rgba(255, 255, 255, 0.9);
    section {
      position: relative;
      padding: 30px;
      background: rgba(0, 0, 128, 0.1);
      margin-top: 40px;
    }
    .section-header {
      display: flex;
      justify-content: center;
      .section-header_title {
        border: 2px solid #2835eb;
        position: relative;
        padding: 12px 14px;
        font-size: 18px;
        width: 92px;
        height: 56px;
        box-sizing: border-box;
        .section-header_title-inner {
          padding: 4px 0;
          background: #090723;
          color: rgba(255, 255, 255, 0.9);
          position: absolute;
          left: -20px;
          top: 9px;
          font-weight: 400;
          font-size: 20px;
          font-family: Tahoma, Helvetica, Arial, sans-serif;
        }
      }
    }
    .section-content {
      display: flex;
      justify-content: space-between;
      padding: 25px 40px;
      h2 {
        font-weight: normal;
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 22px;
      }
    }
    .section-content_left {
      padding: 20px;
      .enter-button {
        margin-left: 40px;
        margin-top: 100px;
      }
    }
    .section-content_right {
      width: 520px;
    }
    section:nth-child(2) {
      background: #100e6a;
      .section-header_title-inner {
        background: #100e6a !important;
      }
    }
  }
  footer {
    margin-top: 50px;
    text-align: center;
    font-size: 12px;
    text-decoration: underline;
  }
  #beian {
    font-size: 12px;
    text-align: center;
    margin-top: 50px;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
